(function () {
    'use strict';

    var formEmbedUpdated = false;

    function updateFormEmbed() {
        if (formEmbedUpdated) {
            return;
        }

        formEmbedUpdated = true;

        var shadowRoot = document.querySelector('form-embed#app-embed').shadowRoot;

        var styleContent = `
        section [data-sizing="form-wrapper"] {
            max-width: 1200px !important;
        }
        
        form {
            margin-top: 2rem;
        }
        
        form button[type="submit"] {
            margin-top: 2rem;
            background-color: var(--color--brand);
            color: var(--button-background-color);
            border-radius: var(--radius-button);
            font-size: calc(var(--font--button-size) / var(--font--size-base) * 1rem);
            font-weight: var(--font--button-weight);
            width: 95%;
        }
        
        form output {
            width: 100%;
            font: var(--forms-body-font);
            margin-top: 10px;
            color: var(--form-error-color);
            line-height: var(--forms-base-font-line-height);
        }
        
        form ._with_error input {
            box-shadow: 0 0 0 2px var(--form-error-color);
        }
        
        @media (min-width: 767px) {
            form {
                flex-direction: row !important;
                flex-wrap: wrap;
            }
            
            form button[type="submit"] {
                width: 100%;
                margin-left: 30px;
            }
        
            form > div {
                width: calc(50% - 42px);
                margin-left: 30px;
            }
            
             form > output {
                margin-left: 30px;
             }
        }
      `;

        if (window.location.pathname.includes('/become-a-dealer')) {
            styleContent += `
             @media (min-width: 767px) {
                form > div:first-of-type {
                    margin-right: 20px;
                }
            
                form > div:nth-of-type(6),
                form > div:nth-of-type(7),
                form > div:nth-of-type(8),
                form > div:nth-of-type(9) {
                    width: 100%;
                }  
             }
            `;
        }

        if (window.location.pathname.includes('/request-vehicle')) {
            styleContent += `
             @media (min-width: 767px) {
                form > div:nth-of-type(9) {
                    width: 100%;
                }  
             }
            `;
        }

        var style = document.createElement('style');
        style.textContent = styleContent;

        shadowRoot.prepend(style);

        waitUntilSubmitButtonIsLoadedAndRun(shadowRoot,function (shadowRoot) {
            setFormValidations(shadowRoot);
            bindListeners(shadowRoot);
        });
    }

    function showError(inputElement, errorMessage) {
        const errorDiv = getOrCreateOutputSibling(inputElement);
        errorDiv.textContent = errorMessage;
        errorDiv.style.display = 'block';

        inputElement.parentElement.classList.add('_with_error');
    }

    function hideError(inputElement) {
        const errorDiv = getOrCreateOutputSibling(inputElement);
        errorDiv.style.display = 'none';

        inputElement.parentElement.classList.remove('_with_error');
    }

    function getOrCreateOutputSibling(inputElement) {
        if (!inputElement) {
            return null;
        }

        var parentElement = inputElement.parentElement;

        var outputElement = parentElement.querySelector('output');

        if (outputElement && outputElement.tagName.toLowerCase() === 'output') {
            return outputElement;
        }

        outputElement = document.createElement('output');

        parentElement.appendChild(outputElement);

        return outputElement;
    }

    function formatWebsiteURL(urlInput) {
        var value = urlInput.value.trim();

        // Remove any existing protocol
        value = value.replace(/^https?:\/\//i, '');

        // Remove www. if present (we'll add it back in a standardized way if needed)
        value = value.replace(/^www\./i, '');

        // If there's a value and it doesn't look like a complete URL, add https://
        if (value && value.length > 0) {
            // Check if it contains at least a dot and some characters
            if (value.includes('.') && value.length > 3) {
                urlInput.value = 'https://' + value;
            } else {
                urlInput.value = value; // Keep as-is if it doesn't look like a URL yet
            }
        }
    }

    function validateWebsiteURL(value) {
        value = value.trim();

        if (!value) {
            return true;
        }

        // Basic URL validation regex
        var urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;

        return urlRegex.test(value);
    }

    function formatPhoneNumber(phoneInput) {
        var value = phoneInput.value.replace(/\D/g, '');

        // Limit to 10 digits maximum
        if (value.length > 10) {
            value = value.substring(0, 10);
        }

        if (value.length >= 6) {
            value = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + '-' + value.substring(6, 10);
        } else if (value.length >= 3) {
            value = '(' + value.substring(0, 3) + ') ' + value.substring(3);
        } else if (value.length > 0) {
            value = '(' + value;
        }

        phoneInput.value = value;
    }

    function validatePhone(phoneInput) {
        var phone = phoneInput.value.replace(/\D/g, '');

        return phone.length === 10;
    }

    function moveOutputElements(shadowRoot) {
        setTimeout(function () {
            shadowRoot.querySelectorAll('form > output').forEach(function (element) {
                element.previousElementSibling.append(element);
            });
        }, 200);
    }

    function setFormValidations(shadowRoot) {
        var phoneInput = shadowRoot.getElementById('custom#phone_number');

        if (phoneInput) {
            // Format as user types
            phoneInput.addEventListener('input', function () {
                formatPhoneNumber(this);
            });

            // Validate on blur
            phoneInput.addEventListener('blur', function () {
                if (!validatePhone(this)) {
                    showError(this, 'Please enter a valid 10-digit phone number.');
                } else {
                    hideError(this);
                    this.classList.remove('error');
                }
            });

            phoneInput.addEventListener('keydown', function (e) {
                if (e.key === 'Backspace' || e.key === 'Delete') {
                    setTimeout(() => {
                        if (this.value.length === 1 && this.value === '(') {
                            this.value = '';
                        }
                    }, 0);
                }
            });
        }

        var websiteInput = shadowRoot.getElementById('custom#company_website');
        
        if (websiteInput) {
            websiteInput.addEventListener('blur', function () {
                if (this.value.trim()) {
                    formatWebsiteURL(this);

                    // Validate after formatting
                    if (!validateWebsiteURL(this.value)) {
                        showError(this, 'Please enter a valid website URL (e.g., example.com)');
                    } else {
                        hideError(this);
                    }
                } else {
                    hideError(this);
                }
            });

            websiteInput.addEventListener('input', function () {
                var value = this.value.trim();

                if (value && value.length > 3) {
                    validateWebsiteURL('https://' + value.replace(/^https?:\/\//i, ''));
                }
            });
        }
    }

    function bindListeners(shadowRoot) {
        shadowRoot.querySelector('button[type="submit"]').addEventListener('click', function () {
            moveOutputElements(shadowRoot);
        });
    }

    function waitUntilSubmitButtonIsLoadedAndRun(shadowRoot, callback) {
        var tries = 0;

        var intervalId = setInterval(function () {
            if (tries === 5) {
                clearInterval(intervalId);

                return;
            }

            if (!shadowRoot.querySelector('button[type="submit"]')) {
                tries = tries + 1;

                return;
            }

            callback(shadowRoot);

            clearInterval(intervalId);
        }, 1000);
    }

    document.addEventListener('DOMContentLoaded', function () {
        var tries = 0;

        var intervalId = setInterval(function () {
            if (tries === 5) {
                clearInterval(intervalId);

                return;
            }

            if (!document.querySelector('form-embed#app-embed')) {
                tries = tries + 1;

                return;
            }

            updateFormEmbed();

            clearInterval(intervalId);
        }, 1000);
    });
})();
